import React, { useState, useEffect, useRef } from "react";
import { useMeasure } from 'react-use';
import {useLoaderData, Link} from 'react-router-dom';
import CreateArea from "../components/CreateArea";
import Group2 from "../components/Group2";
import { getPageContent, getProfileContent, getUser, addBlockToDB, addGroupToDB,
  editGroupOnDB, editBlockOnDB, deleteBlockFromDB, deleteGroupFromDB,
  moveGroupInDB, updateBlockWidthInDB, moveBlockInDB, updateBlockOrderInDB, 
  initialisePageSkins, createGroupLink, breakGroupLink
 } from "../Users";
import { useUser } from "../components/UserContext";
import { useGroupOrder } from '../components/GroupOrderContext';
import '../texteditstyle.css';
import MonitorIcon from '@mui/icons-material/Monitor';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LockIcon from '@mui/icons-material/Lock';
import PersonIcon from '@mui/icons-material/Person';

export async function pageLoader({params}) {
  const type = "page";
  const userId = params.userId;
  const pageAuthor = await getUser(userId);
  const pageCode = params.pageCode;
  const pageContent = await getPageContent(pageCode);
  if (!pageContent || !pageAuthor || Number(pageAuthor.id) !== Number(pageContent.authorId) || pageContent.isProfile === 1) {
      throw new Response("", {
          status: 404,
          statusText: "Not Found",
        });
  }
  return {pageAuthor, pageContent, type};
}

export async function profileLoader({params}) {
  const type = "profile";
  const userId = params.userId;
  const pageAuthor = await getUser(userId);
  const pageContent = await getProfileContent(userId);
  if (!pageContent || !pageAuthor) {
      throw new Response("", {
          status: 404,
          statusText: "Not Found",
        });
  }
  return {pageAuthor, pageContent, type};
}

export default function Page2() {
  const {groupOrder} = useGroupOrder();
  const {pageAuthor, pageContent, type} = useLoaderData();
  const pageSkin = {...pageContent.skin};
  const {currentUser} = useUser();
  const [groups, setGroups] = useState([]);
  const [displayedGroups, setDisplayedGroups] = useState([]);
  const [heights, setHeights] = useState([]);
  const [isCreateOpen, setCreateOpen] = useState(false);
  const [target, setTarget] = useState({groupId: null, groupOrder: null, method: null, blockId: null, blockOrder: null});
  const [isEditing, setIsEditing] = useState(false)
  const groupDisplayOrder = groupOrder === 1 || pageContent.pageId === 1 || type === "profile"? true : false;
  const [navigatorOpen, setNavigatorOpen] = useState(false) 
  const [navigatorSiblings, setNavigatorSiblings] = useState(false)
  const [navDirectSiblings, setNavDirectSiblings] = useState([false, false])
  const recalcTimerRef = useRef(null);
  const recalcArgsRef  = useRef(null);
  const groupsRef = useRef(groups);
  useEffect(() => { groupsRef.current = groups; }, [groups]);
  const dropdownRef = useRef(null);
  const [titleRef, {right: titleRight}] = useMeasure();
  const [titleFontSize, setTitleFontSize] = useState(70);
  const titleFontRef = useRef(titleFontSize);
  useEffect(() => { titleFontRef.current = titleFontSize; }, [titleFontSize]);
  const [maxTitleWidth, setMaxTitleWidth] = useState();
  const [heightChecked, setHeightChecked] = useState(false);


  useEffect(() => { //initialise
    document.title = 
      type === "page" ? `${pageContent.title} - ${pageAuthor?.username}` 
      : `${pageAuthor?.username} - Profile`;
    const initializegroupStartingHeights = () => {
      let initializedHeights = [];
      for (let i = 0; i < pageContent.groups.length; i++) {
        initializedHeights.push(40)
      }
      setHeights(initializedHeights);
    };

    if (pageContent.groups.length >= 0) {
      if (pageContent.siblings) { //initialise sibling values
        pageContent.siblings.forEach((page) => {
          if ((page.isPrivate === 0 || currentUser.id === pageAuthor.id) && page.id !== pageContent.pageId) {
            setNavigatorSiblings(true);
          }
        });
        if (navigatorSiblings) {
          const currentPagePlacing = pageContent.siblings.findIndex(page => page.id === pageContent.pageId)
          let directSiblings = [false, false];
          if (currentUser.id === pageAuthor.id) {
            directSiblings[0] = pageContent.siblings[currentPagePlacing - 1]?.pageCode;
            directSiblings[1] = pageContent.siblings[currentPagePlacing + 1]?.pageCode;
          } else {
            for (let i = currentPagePlacing - 1; i >= 0; i--) {
              if (pageContent.siblings[i].isPrivate === 0) {
                directSiblings[0] = pageContent.siblings[i].pageCode;
                i = -1;
              }
            }
            for (let i = currentPagePlacing + 1; i <= pageContent.siblings.length; i++) {
              if (pageContent.siblings[i]?.isPrivate === 0) {
                directSiblings[1] = pageContent.siblings[i].pageCode;
                i = pageContent.siblings.length + 1;
              }
            }
          }
          setNavDirectSiblings(directSiblings)
        }
      } else {
        setNavigatorSiblings(false);
      }
      
    setGroups(() => {
      let groups = [...pageContent.groups];
      if (window.innerWidth < 600) {
        groups.forEach((group) => {
          for (let i = 0; i < group.blocks.length; i++) {
            group.blocks[i].columnStart = 0;
            group.blocks[i].columnEnd = 12;
          }
        })
      }
      return (groups);
    })
      
      initialisePageSkins(pageContent.skin);
      if (pageContent.groups.length > 0) {
        initializegroupStartingHeights();
      }
    } 
  }, [pageContent, currentUser.id, navigatorSiblings, pageAuthor, type])

  useEffect(() => { //reverse order
    if (!groupDisplayOrder) {
      setDisplayedGroups(groups.toReversed());
    } else {
      setDisplayedGroups(groups);
    }
  }, [groupDisplayOrder, groups])

  useEffect(() => { //page sibling menu
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setNavigatorOpen(false);
      }
    }
  
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => { //check/adjust titleFontSize
    if (titleRight > 0 && !heightChecked) {
      const maxPageTitleWidth = window.innerWidth > 600 ? window.innerWidth * 0.9 - 160 : window.innerWidth * 0.9 - 80;
      setMaxTitleWidth(maxPageTitleWidth);
      if (titleRight > maxPageTitleWidth) {
        const newFontSize = Math.round((maxPageTitleWidth / titleRight) * 70);
        setTitleFontSize(newFontSize);
      }
      setHeightChecked(true);
    }
  }, [titleRight, titleFontSize, heightChecked]);

  function updateCreateOpen() { //when closing, delete target (so before that, confirm if they want it)
    setCreateOpen((prevVal) => {
        return !prevVal;
    })
  }

  function createGroup(){
    if (groups.length !== 0) {
      var ids = [];
      for (let i = 0; i < groups.length; i++) {
        ids.push(groups[i].id);
      }
      const newId = ids.reduce((a, b) => Math.max(a,b), -Infinity) + 1;
      setTarget({groupId: newId, groupOrder: groups.length,  method: "addGroup", blockId: null, blockOrder: null})
    } else {
      setTarget({groupId: 0, groupOrder: groups.length, method: "addGroup", blockId: null, blockOrder: null})
    }
    
    updateCreateOpen();
  }

  function updateTarget(groupId, groupOrder, method, blockId, blockOrder){
    setTarget({groupId: groupId, groupOrder: groupOrder, method: method, blockId: blockId, blockOrder: blockOrder});
    updateCreateOpen();
  }

  async function addBlockToGroup(groupId, groupOrder, blockId, blockOrder, blockType, blockRetract, blockTitle, blockContent) {
    const newBlockId = await addBlockToDB(groupId, pageContent.pageId, blockOrder, blockType, blockRetract, pageSkin.columnStart, pageSkin.columnEnd, blockTitle, blockContent);
  
    setGroups(prevGroups => {
      const updatedGroups = [...prevGroups];
      const existingBlock = updatedGroups[groupOrder].blocks.find(block => block.id === newBlockId);
      if (!existingBlock) {
        updatedGroups[groupOrder].blocks.push({
          id: newBlockId || blockId,
          order: blockOrder,
          type: blockType,
          retract: blockRetract,
          title: blockTitle,
          content: blockContent,
          columnStart: window.innerWidth > 600 ? pageSkin.columnStart : 0,
          columnEnd: window.innerWidth > 600 ? pageSkin.columnEnd : 12,
        });
      }
      return updatedGroups;
    });
  
    // Reset target after block addition
    setTarget(({ groupId: null, groupOrder: null, method: null, blockId: null, blockOrder: null }));
  }

  async function addGroup(newGroup) {
    // Call addGroupToDB and wait for it to complete
    await addGroupToDB(pageContent.pageId, newGroup);
  
    // After newGroup has been updated with IDs, add it to the state
    setGroups(prevGroups => [...prevGroups, newGroup]);
    setHeights(prevHeights => [...prevHeights, 40]);
    setTarget(({ groupId: null, groupOrder: null, method: null, blockId: null, blockOrder: null }));
  }

  function updateGroupHeight(order, newHeight) {
    setHeights(prevHeights => {
      const updatedHeights = [...prevHeights];
      updatedHeights[order] = newHeight;
      return updatedHeights;
    });
  }

  function updateBlockWidth( groupOrder, blockId, blockOrder, newColumnStart, newColumnEnd) {
      setGroups(prevGroups => {
      const updatedGroups = [...prevGroups];
      updatedGroups[groupOrder].blocks[blockOrder] = {
        ...updatedGroups[groupOrder].blocks[blockOrder],
        columnStart: newColumnStart,
        columnEnd: newColumnEnd
      }
      return updatedGroups;
    })
    updateBlockWidthInDB(blockId, newColumnStart, newColumnEnd)
  }

  function deleteBlock(groupId, groupOrder, blockId, blockOrder) {
    setGroups(prevGroups => {
      const updatedGroups = [...prevGroups];
      var updatedGroup = prevGroups[groupOrder].blocks.filter((blockItem) => blockItem.id !== blockId);
      updatedGroup = cleanOrder(updatedGroup);
      updatedGroups[groupOrder].blocks = updatedGroup;
      return (updatedGroups);
    });
    deleteBlockFromDB(groupId, blockId, blockOrder)
  }

  function deleteGroup(id, order) {
    setGroups(prevGroups => {
      var updatedGroups = [...prevGroups]
      updatedGroups = updatedGroups.filter((group) => group.id !== id)
      updatedGroups = cleanOrder(updatedGroups);
      return (updatedGroups)
    });
    setHeights(prevHeights => prevHeights.filter((_, index) => index !== order));
    deleteGroupFromDB(pageContent.pageId, id, order);
  }

  function cleanOrder(things) {
    // Deep copy the array and the objects inside it
    return things.map((blockItem, index) => ({
      ...blockItem, // Spread the existing properties of the block
      order: index  // Update the order
    }));
  }

  function moveGroup( groupOrder, where) {
    var trueWhere = where;
    if (groupDisplayOrder) {
      trueWhere = where * (-1);
    }
    var destination = groupOrder + trueWhere;
    var hitsWalls=0;
    if (destination <= 0){ //1 hits top wall, 2 hits bottom wall
      hitsWalls = 1
      destination = 0;
    }
    if (destination >= groups.length - 1) {
      hitsWalls = 2
      destination = groups.length - 1;
    }
    moveGroupInDB(pageContent.pageId, groupOrder, destination, groups.length)
    setGroups(prevGroups => {
      var updatedGroups = [...prevGroups]
      if (hitsWalls === 1) {
        if (groupOrder !== 0) {
          const movingGroup = updatedGroups[groupOrder];
          updatedGroups = updatedGroups.filter((_, index) => index !== groupOrder);
          updatedGroups.unshift(movingGroup);
          updatedGroups = cleanOrder(updatedGroups);
          setHeights(prevHeights => {
            var updatedHeights = [...prevHeights];
            var movingHeight = updatedHeights[groupOrder]
            updatedHeights = updatedHeights.filter((_, index) => index !== groupOrder);
            updatedHeights.unshift(movingHeight);
            return updatedHeights;
          })
        }
      } else if (hitsWalls === 2){
        if (groupOrder !== groups.length - 1) {
          const movingGroup = updatedGroups[groupOrder];
          updatedGroups = updatedGroups.filter((_, index) => index !== groupOrder);
          updatedGroups.push(movingGroup);
          updatedGroups = cleanOrder(updatedGroups);
          setHeights(prevHeights => {
            var updatedHeights = [...prevHeights];
            var movingHeight = updatedHeights[groupOrder]
            updatedHeights = updatedHeights.filter((_, index) => index !== groupOrder);
            updatedHeights.push(movingHeight);
            return updatedHeights;
          })
        }
      } else {
        const movingGroup = updatedGroups[groupOrder];
        updatedGroups = updatedGroups.filter((_, index) => index !== groupOrder);
        updatedGroups.splice(destination,0 ,movingGroup);
        updatedGroups = cleanOrder(updatedGroups);
        setHeights(prevHeights => {
          var updatedHeights = [...prevHeights];
          var movingHeight = updatedHeights[groupOrder]
          updatedHeights = updatedHeights.filter((_, index) => index !== groupOrder);
          updatedHeights.splice(destination,0 ,movingHeight);
          return updatedHeights;
        })
      }
    return updatedGroups;
    });
  }

  function moveBlock(groupId, groupOrder, blockId, blockOrder, desiredOrder, newColumnStart, newColumnEnd) {
    return new Promise((resolve) => {
      moveBlockInDB(groupId, blockOrder, desiredOrder, groups[groupOrder].blocks.length, newColumnStart, newColumnEnd);
  
      setGroups(prevGroups => {
        const updatedGroups = [...prevGroups];
        let movingBlock = updatedGroups[groupOrder].blocks[blockOrder];
        movingBlock.columnStart = newColumnStart;
        movingBlock.columnEnd = newColumnEnd;
  
        updatedGroups[groupOrder].blocks = updatedGroups[groupOrder].blocks.filter((_, index) => index !== blockOrder);
        updatedGroups[groupOrder].blocks.splice(desiredOrder, 0, movingBlock);
  
        updatedGroups[groupOrder].blocks = cleanOrder(updatedGroups[groupOrder].blocks);
  
        return updatedGroups;
      });

      resolve();
    });
  }

  function recalcBlockOrder(groupId, groupOrder, originalSH) {
    if (recalcTimerRef.current) clearTimeout(recalcTimerRef.current);

    recalcArgsRef.current = [groupOrder, originalSH];

    recalcTimerRef.current = setTimeout(() => {
      const [gOrder, oSH] = recalcArgsRef.current;

      const SHOnly = [];
      const CSOnly = [];
      const SHMostlyInOrder = [];
      const placementsPrettyMuch = [];
      const finalPlacements = []; 

      for (let i = 0; i < oSH.length; i++) {
        SHOnly.push(oSH[i].SH);
        CSOnly.push(oSH[i].CS);
      }
      const SHDec = [...SHOnly];
      const processedIndexes = new Array(SHOnly.length).fill(false); 
      for (let i = 0; i < oSH.length; i++) {
        const newLSH = Math.min(...SHDec);  
        const iOfNLSH = SHOnly.findIndex((sh, idx) => sh === newLSH && !processedIndexes[idx]); 
        SHMostlyInOrder.push(newLSH);  
        placementsPrettyMuch.push(iOfNLSH); 
        const fakeIndex = SHDec.indexOf(newLSH); 
        SHDec.splice(fakeIndex, 1); 
        processedIndexes[iOfNLSH] = true;  
      }
      for (let i = 0; i < oSH.length; i++) {
        const dupeIndexes = [];
        SHMostlyInOrder.forEach((SH, index) => {
          if (SH === SHMostlyInOrder[i]) dupeIndexes.push(index);
        });
        if (dupeIndexes.length > 1) {
          const dupePlacementIndexes = [];
          dupeIndexes.forEach((index) => {
            // const originalIndex = placementsPrettyMuch[index];
            dupePlacementIndexes.push(index); 
          });
          const sortedDupeIndexes = dupePlacementIndexes.sort((a, b) => {
            const originalIndexA = placementsPrettyMuch[a];  
            const originalIndexB = placementsPrettyMuch[b]; 
            return CSOnly[originalIndexA] - CSOnly[originalIndexB];  
          });
          sortedDupeIndexes.forEach((sortedIndex) => {
            finalPlacements.push(placementsPrettyMuch[sortedIndex]);
          });
          i += dupeIndexes.length - 1;
        } else {
          finalPlacements.push(placementsPrettyMuch[i]);
        }
      }

      const needsReorder = finalPlacements.some((place, index) => place !== index);

      if (needsReorder) {
        const updatedSH = [...oSH];
        const reorderedSH = [];
        finalPlacements.forEach((placement, i) => {
          reorderedSH[i] = updatedSH[placement];
        });

        finalPlacements.pop();

        const currentGroups = groupsRef.current;
        const group = currentGroups?.[gOrder];
        if (!group) return;

        updateBlockOrderInDB(group.id, finalPlacements, group.blocks?.length ?? 0);

        // update UI
        setTimeout(() => {
          setGroups(prevGroups => {
            const updatedGroups = [...prevGroups];
            const groupToUpdate = updatedGroups[gOrder];
            if (!groupToUpdate) return prevGroups;

            const movingBlocks = [...groupToUpdate.blocks];
            let reorderedBlocks = [];
            finalPlacements.forEach((placement, i) => {
              reorderedBlocks[i] = movingBlocks[placement];
            });
            reorderedBlocks = cleanOrder(reorderedBlocks);

            updatedGroups[gOrder] = { ...groupToUpdate, blocks: reorderedBlocks };
            return updatedGroups;
          });
        }, 0);
      }
    }, 30);

    return originalSH;
  }

  function editGroupTitle(groupId, groupOrder, newGroupTitle) {
    setGroups ((prev) => {
      var updatedGroups = [...prev];
      updatedGroups[groupOrder].title = newGroupTitle;
      return updatedGroups;
    })
    editGroupOnDB(groupId, newGroupTitle);
    setTarget(({groupId: null, groupOrder: null, method: null, blockId: null, blockOrder: null}));
  }

  function editBlock(groupId, groupOrder, blockId, blockOrder, newBlockType, newBlockRetract, newBlockTitle, newBlockContent) {
    setGroups ((prev) => {
      var updatedGroups = [...prev];
      updatedGroups[groupOrder].blocks[blockOrder].type = newBlockType;
      updatedGroups[groupOrder].blocks[blockOrder].title = newBlockTitle;
      updatedGroups[groupOrder].blocks[blockOrder].content = newBlockContent;
      updatedGroups[groupOrder].blocks[blockOrder].retract = newBlockRetract;
      return updatedGroups;
    })
    editBlockOnDB(blockId, newBlockType, newBlockRetract, newBlockTitle, newBlockContent);
    setTarget(({groupId: null, groupOrder: null, method: null, blockId: null, blockOrder: null}));
  }

  async function handleCreateGroupLink(groupId, groupOrder) {
    const {newLink} = await createGroupLink(groupId);
    navigator.clipboard.writeText(`willow-web.net/group/${newLink}`);
    setGroups ((prev) => {
      var updatedGroups = [...prev];
      updatedGroups[groupOrder].link = newLink;
      return updatedGroups;
    })
  }

  function handleBreakGroupLink(groupId, groupOrder) {
    setGroups ((prev) => {
      var updatedGroups = [...prev];
      updatedGroups[groupOrder].link = null;
      return updatedGroups;
    })
    breakGroupLink(groupId);
  }

  return (
    <div>
      {pageSkin.backgroundImage && <img id="page-background" src={pageSkin.backgroundImage} alt="background"/>}
      <div className="page-head">
        <div className="page-title">
          {pageAuthor.pfp? <img className="actual-creator-pfp" src={`${pageAuthor.pfp}`} alt="mock pfp" /> :
          <div className="actual-creator-pfp"><PersonIcon className="creator-default-pfp"/></div>}
          <h2 className="title-text" ref={titleRef} style={{fontSize: `${titleFontSize}px`, ...(heightChecked ? {maxWidth: `${maxTitleWidth}px`, overflow: "hidden"} : {})}}>{type === "page"? pageContent.title : pageAuthor?.username}</h2> 
          {type === "page" ? <h3>by <Link to={"/profile/" + pageContent.authorId}>{pageAuthor?.username}</Link></h3> : <h3>{pageAuthor?.name}</h3>}
        </div>
        {navigatorSiblings? <div className="page-head-navigator" ref={dropdownRef}>
          <div className="page-nav-main">
            {navDirectSiblings[0] && <Link className="page-nav-button page-nav-button1" to={`/${pageAuthor.id}/page/${navDirectSiblings[0]}`}><ExpandMoreIcon style={{transform: 'rotate(90deg)'}}/></Link>}
            <div onClick={()=> {setNavigatorOpen(prev => !prev)}} >
              {pageContent.title} <ExpandMoreIcon style={navigatorOpen? {transform: 'scale(-1, -1)'} : {}}/>
            </div>
            {navDirectSiblings[1] && <Link className="page-nav-button" to={`/${pageAuthor.id}/page/${navDirectSiblings[1]}`}><ExpandMoreIcon style={{transform: 'rotate(270deg)'}}/></Link>}
          </div>
          {navigatorOpen && (
          <div className="page-nav-option-container">
            {pageSkin.backgroundImage && (pageSkin.pageBackgroundColor === "rgba(0, 0, 0, 0)" || pageSkin.pageBackgroundColor === "#00000000")&& 
            <img id="page-navigator-background" src={pageSkin.backgroundImage} alt="background"/>}
            {pageContent.siblings.map((page) => {
              // Check if the page is not private or if the current user is the page author
              if (page.isPrivate === 0 || (page.isPrivate === 1 && currentUser.id === pageAuthor.id)) {
                return (
                  <Link className={page.id === pageContent.pageId? "page-nav-option nav-current-page" : "page-nav-option"} to={`/${pageAuthor.id}/page/${page.pageCode}`}>
                    {page.title} {page.isPrivate === 1 && <LockIcon id="nav-lock"/>}
                  </Link>
                );
              } else {
                return null; // Do not render anything if conditions are not met
              }
            })}
          </div>)}
        </div> : null}
      </div>
      
      {pageAuthor.id === currentUser.id && currentUser.status !== -1 && <div id="page-options">
        <div className="button" onClick={() => {setIsEditing((prev) => {return !prev})}}>{isEditing? <MonitorIcon alt="display mode"/> : <EditIcon alt="edit mode"/>}</div>
        {isEditing && ((currentUser.status === 0 && currentUser.blockCount < 10) || 
          (currentUser.status === 1 && currentUser.blockCount < 10) || currentUser.status === 2)  &&
          <div className="button" onClick={createGroup}><AddIcon /></div>
        }
      </div>}
      {pageAuthor.id === currentUser.id && <CreateArea 
        onAdd={addGroup} 
        updateOpen={updateCreateOpen} 
        isOpen={isCreateOpen} 
        setOpen={setCreateOpen} 
        target={target}
        addBlockToGroup={addBlockToGroup}
        groups={groups}
        editGroupTitle={editGroupTitle}
        editBlock={editBlock}
        skin={pageContent.skin}
        highlightColors={pageAuthor.highlightColors}
      />}
      <div id="block-area" style={{left:`${window.innerWidth <= 600? isEditing ? -4 : -0 : (88 - pageSkin.groupWidth) / 2}vw`}}>
        {displayedGroups.map((groupItem, index) => (
          <Group2
            key={groupItem.id}
            groupId={groupItem.id}
            groupOrder={groupItem.order}
            title={groupItem.title}
            blocks={groupItem.blocks}
            timeCreated={groupItem.timeCreated}
            link={groupItem.link}
            height={heights[groupItem.order]}
            onHeightChange={updateGroupHeight}
            onWidthChange={updateBlockWidth}
            recalcOrder={recalcBlockOrder}
            onDelete={deleteGroup}
            deleteBlock={deleteBlock}
            updateGroup={updateTarget}
            moveGroup={moveGroup}
            moveBlock={moveBlock}
            isEditing={isEditing}
            isProfile={type === "page"? false : true}
            addBlockToGroup={addBlockToGroup}
            total={pageContent.total}
            pageAuthor={pageAuthor.id}
            currentUser={currentUser.id}
            pageSkin={pageSkin}
            createGroupLink={handleCreateGroupLink}
            breakGroupLink={handleBreakGroupLink}
          />
        ))}
      </div>
      <div id="space"></div>
    </div>
  );
}